<h2 class="report-preview" mat-dialog-title>Report Preview   <button class="pull-right" mat-button mat-dialog-close><img src="../../../../assets/images/closebtn.png"></button></h2>
<mat-dialog-content>
   <app-report-data-list></app-report-data-list>
</mat-dialog-content>
